<template>
  <div class="col-12" style="padding-right: 0 !important; padding-left: 0 !important;">
    <BloodPressureResult v-for="(test, index) in userBPTests" :key="'bptest-' + index" :sharedTest="sharedTest" :printing="printing" :testIndex="index" :fetchedTests="fetchedTests" :showMode="showMode" @modeChanged="modeChanged" @openDicussion="(test, userInfo) => $emit('openDicussion', test, userInfo)"/>
  </div>
</template>

<script>
import BloodPressureResult from './BloodPressureResult.vue'

export default {
  components: {
    BloodPressureResult
  },
  props: {
    sharedTest: Object,
    printing: Boolean
  },
  computed: {
    userBPTests () {
      if (this.showMode === 'calendar') {
        return this.fetchedTests
      }

      if (!this.sharedTest || !this.sharedTest.last_tests || this.sharedTest.last_tests.length === 0) {
        return null
      }
      var bpTests = this.sharedTest.last_tests.filter(test => {
        return test.type === 'bp'
      })
      if (bpTests.length === 0) {
        return null
      }
      return bpTests
    }
  },
  data: () => ({
    showMode: 'last',
    fetchedTests: [],
    unsubscribe: null
  }),
  methods: {
    modeChanged (mode) {
      this.showMode = mode
    }
  },
  mounted () {
    let that = this
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'test/bpTestsSuccess') {
        let tests = mutation.payload
        if (tests.length > 0 && this.showMode === 'calendar') {
          this.fetchedTests = tests
        }
      }
      if (that.testIndex === 0 && mutation.type === 'test/bpTestsFailure') {
        this.fetchedTests = []
      }
    })
  },
  destroyed () {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/BloodPressureResults.vue